module.exports = __webpack_public_path__ + "img/icon3.001dc569.svg";